import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "editionMint" }, "NFT Mint:")
], -1)
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "nes-field mt-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "newMetadataData" }, "New Metadata as JSON (optional):", -1)
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "nes-field mt-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "newUpdateAuthority" }, "New Update Authority (optional):")
], -1)
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "primarySaleHappened",
  class: "mt-5"
}, "Primary Sale Happened? (optional):", -1)
const _hoisted_11 = { class: "nes-select" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: null }, "select", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: true }, "yes, it's over", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "Update successful! 🎉", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Loading your updated NFT... (might take a min or two)")
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionMark = _resolveComponent("QuestionMark")!
  const _component_StdNotifications = _resolveComponent("StdNotifications")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_ExplorerLink = _resolveComponent("ExplorerLink")!
  const _component_NFTViewCard = _resolveComponent("NFTViewCard")!
  const _component_NotifySuccess = _resolveComponent("NotifySuccess")!
  const _component_ContentTooltipMetadata = _resolveComponent("ContentTooltipMetadata")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateNFT && _ctx.updateNFT(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "editionMint",
          class: "nes-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editionMint) = $event)),
          placeholder: _ctx.DEFAULTS.MASTER_MINT
        }, null, 8, _hoisted_3), [
          [_vModelText, _ctx.editionMint]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          _createVNode(_component_QuestionMark, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal('tooltipMetadata')))
          })
        ]),
        _withDirectives(_createElementVNode("textarea", {
          rows: "5",
          id: "newMetadataData",
          class: "nes-input",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newMetadataData) = $event)),
          placeholder: _ctx.DEFAULTS.METADATA
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.newMetadataData]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "newUpdateAuthority",
          class: "nes-input",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newUpdateAuthority) = $event)),
          placeholder: _ctx.DEFAULTS.UPDATE_AUTHORITY
        }, null, 8, _hoisted_9), [
          [_vModelText, _ctx.newUpdateAuthority]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_10,
        _createVNode(_component_QuestionMark, { external: "https://docs.metaplex.com/nft-standard#token-metadata-program" })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("select", {
          required: "",
          id: "primarySaleHappened",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.primarySaleHappened) = $event))
        }, _hoisted_14, 512), [
          [_vModelSelect, _ctx.primarySaleHappened]
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["nes-btn is-primary mt-5", { 'is-disabled': _ctx.isLoading || !_ctx.isConnected }]),
        disabled: _ctx.isLoading || !_ctx.isConnected,
        type: "submit"
      }, " Update NFT ", 10, _hoisted_15)
    ], 32),
    _createVNode(_component_StdNotifications, {
      "is-connected": _ctx.isConnected,
      "is-loading": _ctx.isLoading,
      error: _ctx.error
    }, null, 8, ["is-connected", "is-loading", "error"]),
    (_ctx.txId)
      ? (_openBlock(), _createBlock(_component_NotifySuccess, {
          key: 0,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            (!_ctx.updatedNFT)
              ? (_openBlock(), _createBlock(_component_LoadingIcon, {
                  key: 0,
                  align: "left",
                  class: "mt-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_ExplorerLink, { "tx-id": _ctx.txId }, null, 8, ["tx-id"]),
                  _createVNode(_component_NFTViewCard, {
                    n: _ctx.updatedNFT,
                    class: "text-black"
                  }, null, 8, ["n"])
                ]))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isModalVisible('tooltipMetadata'))
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 1,
          title: "How to format Metadata?",
          onHideModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideModal('tooltipMetadata')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ContentTooltipMetadata)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}